<template>
  <div>
    <v-breadcrumbs class="primary--text" :items="items" divider="/" />
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
};
</script>
